<template>
    <div class="card_list">
        <div class="list" v-for="(cards, index) in cardlist" :key="index">
            <common-link :item='cards' :page="cardli"></common-link>
        </div>
    </div>
</template>
<script>
import commonLink from './commonLink'
export default {
    data() {
      return {
        cardlist:[],
        cardli:'cardlist'
      }
    },
    components:{
      commonLink
    },
    props: ['card'],
    watch:{
      card:{
        handler(newName, oldName) {
          this.cardlist=newName
        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/components/cardlist.vue